<style lang="less" scoped>
@import "./index.less";
</style>
<style>
.custom-radio {
  column-gap: 55px;
  margin-right: 0;
  margin-left: 15px;
  font-size: 13px;
}
</style>
<template>
  <div class="car-plate-binding">
    <div class="img-wrap">
      <img src="../../../../assets/images/image232.png" width="89" height="87" alt="">
      <div>为了给您更好的行车体验，请准确填写相关信息哦～</div>
    </div>
    <div class="step">
      <div class="step-number">
        <div class="point"><span>1</span></div>
        <div class="hr"></div>
        <div class="point"><span>2</span></div>
        <div class="hr"></div>
        <div class="point active"><span>3</span></div>
      </div>
    </div>
    <div class="plate">
      <div class="title">
        <i>*</i>
        <span>请输入您的表显里程</span>
      </div>
      <div class="input-wrap">
        <input type="text" v-model.number="total_miles" placeholder="请输入您的表显里程数">
        <span>/km</span>
      </div>
    </div>
    <!-- <div  class="plate">
      <div class="title">
        <i>*</i>
        <span>您的车辆是否支持自动启停？</span>
      </div>
      <van-radio-group v-model="radio1"  class="custom-radio" direction="horizontal">
        <van-radio name="1" shape="square">YES</van-radio>
        <van-radio name="2" shape="square">NO</van-radio>
      </van-radio-group>
    </div>
    <div  class="plate">
      <div class="title">
        <i>*</i>
        <span>车辆类型？</span>
      </div>
      <van-radio-group v-model="radio" class="custom-radio" direction="horizontal">
        <van-radio name="1" shape="square">燃油</van-radio>
        <van-radio name="2" shape="square">纯电</van-radio>
        <van-radio name="3" shape="square">油电混合</van-radio>
      </van-radio-group>
    </div> -->
    <div style="text-align: center;"><button class="submit" @click="submitHandle">提交</button></div>
  </div>
</template>

<script>
import { RadioGroup, Radio } from 'vant';
import { errorModal } from '../../../../assets/js/xjcommon';
export default {
  name: 'CarText',
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
  data() {
    return {
      total_miles: 5
    }
  },
  mounted() {
    this.total_miles = this.$store.state.bindData.totalMiles;
  },
  methods: {
    submitHandle() {
      const data = {
        imei: this.$store.state.bindData.imei,
        sn: this.$store.state.bindData.sn,
        carSeriesId: this.$store.state.bindData.series_id,        // 车系id
        carLicense: this.$store.state.bindData.car_license,        // 车系id
        totalMiles: this.total_miles,    // 总里程，保留2位小数
      }

      this.$axios.post('/v3/u/user/bindVehicle', data).then(res => {
        if (res.data.ret === 0) {
          this.setDefaultImei(data.imei)
        } else {
          this.$dialog({
            message: res.data.msg ? res.data.msg + '（' + res.data.ret + '）' : '绑定设备失败（' + res.data.ret + '）'
          })
        }

      })
    },
    setDefaultImei(imei) {
      this.$axios.post('/v3/u/user/setFavoriteVehicle', { imei: imei }).then(res => {
        if (res.data.ret === 0) {
          this.$cookies.set('imei', imei);
          this.$router.replace('/');
        } else {
          this.$dialog({
            message: res.data.msg ? res.data.msg + '（' + res.data.ret + '）' : '设置缺省设备失败（' + res.data.ret + '）'
          })
        }
      })
    },

  }
}
</script>
